import React, {Component} from 'react'

import CRUDManagerGenerator from '../generators/CRUDGenerator'
import {checkPermission, CAN_CREATE_PROJECT_FEE_TYPES, CAN_EDIT_PROJECT_FEE_TYPES} from "../../../lib/permissions";

const create = {
    table: 'project_charge_types',
    mutationType: 'upsert_',
    schema: {
        title: 'Create Project Fee Type',
        type: 'object',
        required: ['description'],
        properties: {
            description: {type: 'string', title: 'Description'}
        }
    }
}

const update = {
    table: 'project_charge_types',
    mutationType: 'upsert_',
    schema: {
        title: 'Update Project Fee Type',
        type: 'object',
        required: ['description'],
        properties: {
            project_charge_type_id: {type: 'integer'},
            description: {type: 'string', title: 'Description'}
        }
    },
    uiSchema: {
        project_charge_type_id: {"ui:widget": "hidden"},
    },
}

const read = {
    title: 'Project Fee Types',
    description: 'Project fee types allow you to define how the project will be charged.',
    table: 'project_charge_types',
    fields: ['project_charge_type_id', 'description'],
    uniqueKey: 'project_charge_type_id',
    columns: [
        {Header: 'ID', accessor: 'project_charge_type_id', maxWidth: '100'},
        {Header: 'Desc', accessor: 'description'}
    ]
}

const config = {
    create,
    read,
    update
}


const CRUDManager = CRUDManagerGenerator(config)

class ProjectFeeTypes extends Component{

    render(){
        return (
            <CRUDManager
                canCreate={checkPermission(CAN_CREATE_PROJECT_FEE_TYPES)}
                canEdit={checkPermission(CAN_EDIT_PROJECT_FEE_TYPES)}
            />
        )
    }
}

export default ProjectFeeTypes